import { render, staticRenderFns } from "./OrderCustomerinfo.vue?vue&type=template&id=47166d3e&scoped=true&"
import script from "./OrderCustomerinfo.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47166d3e",
  null
  
)

export default component.exports